import { useEffect, useState } from 'react';
import { MustLogIn } from '../session';
import { AdminPageLayout } from '../ratpack-ui/src/pages/AdminPageLayout';
import { adminDefaults, hotPink } from './components';
import { Accordion, Badge, Card, Group, Loader, Modal, Skeleton, Space, Stack, Table, Tooltip } from '@mantine/core';
import { DAY, locationIDList, Operator, OperatorList, Option, RPLocation } from '../../../src/types'; /// SHARED
import { Anchor } from '../ratpack-ui/src/components/Anchor/Anchor';
import { atomFamily, useRecoilState } from 'recoil';
import { GET, POST } from '../api';
import { Button } from '../ratpack-ui/src/components/Button/Button';
import { Select } from '../ratpack-ui/src/components/Select/Select';
import { DatePicker } from '../ratpack-ui/src/components/DatePicker/DatePicker';
import { DepotList } from '../../../src/types2'; /// SHARED
import iconBaby from '../ratpack-ui/src/assets/images/icon-baby.svg'


type operatorConfigQuery = {

}
type operatorConfigResponse = {
    operators:Record<Operator, {
        locations: any,
        options: any,
        operator: any,
    }>,
}
const getOperatorConfig = async ({  }: operatorConfigQuery): Promise<operatorConfigResponse> => {
    return await GET(`/api/operator-config?overview=1&cached=1`)
}

const operatorConfigAtom = atomFamily<operatorConfigResponse, operatorConfigQuery>({
    key: 'operatorConfig',
    default: getOperatorConfig
})

const listKeysWithValue = (obj:Record<string,any>, value:any) => Object.entries(obj).filter(([k,v])=>v==value).map(([k,v])=>k)
const sortKnownUnknown = (list:Array<number|string>, known:Record<RPLocation,number|string>) => {
    return {
        unknown: list.map((id,i) => !Object.values(known).some(k => k==id) ? [id,i] : null).filter(Boolean),
        known: list.map((id,i) => !Object.values(known).some(k => k==id) ? [id,i] : null).filter(Boolean),
        missing: Object.entries(known).filter(([k,v])=>!list.includes(v)).map(([k,v])=>k).filter(Boolean),
    }
}

const WarningRed = '#FFCDC1'
type vehicleInfo = {
    id: string|number,
    name: string,
}
type vehicleAvailability = {
    known: Array<vehicleInfo>,
    avail: Array<vehicleInfo>,
    info: vehicleInfo,
    isUnknown: boolean,
    isUnavailable: boolean,
    operator: string,
    k: string,
    rp_id: string,
    id: string|number,
}

const red = `#FF5722`
const orange = `#FFA726`
const yellow = `#FFD54F`
const green = `#40c057`
const lightgreen = `lightgreen`
const grey = `#9CA3AF`

function OperatorBlock({k,operator,setLModal,setVModal}){

    const [location,setLocation] = useState(null)
    const [date,setDate] = useState(new Date(Date.now()+(80*DAY)))
    const [response,setResponse] = useState(null)
    const op = response ?? operator
    const [loading,setLoading] = useState(false)

    // const {
    //     known: knownL,
    //     unknown: unknownL,
    //     missing: missingL,
    // } = sortKnownUnknown((operator?.locations??[]).map(l=>l?.id), operator.operator?.config?.locations??[])
    const country = k.split('.')[0] as 'au'|'nz'
    const availableVehicles = op?.options?.available??[] as Array<{id:string,name:string}>
    const knownVehicles = op?.operator?.products??[] as Array<{id:string,name:string}>
    const not = (n:string='unknown') => (s:string) => s == n ? null : s
    const allVehicles = Object.fromEntries([
        ...Object.values(availableVehicles),
        ...Object.values(knownVehicles),
    ].map(({id,name,rp_id}) => {
        const k = not('unknown')(id) ?? rp_id  ?? id ?? `(${name})`
        const known = knownVehicles.filter(({id})=>id==k)
        const avail = availableVehicles.filter(({id})=>id==k)
        const info = known[0] ?? avail[0]
        // console.log({k,known,avail,info,id,rp_id})
        const isUnknown = !known.length
        const isUnavailable = !avail.length
        return [k, {
            known,
            avail,
            info,
            isUnknown,
            isUnavailable,
            operator:op,
            k,
            rp_id,
            id,
        } as vehicleAvailability]
    }))
    // const locationOptions = Object.entries(operator.operator?.config?.locations??op.operator?.locations??op.locations??{}).map(([label,value]:[any,any])=>({
    //     value:value?.id??value?.toString(),
    //     label:(value?.name??value?.location??value?.city??label)?.split(' - ')[0],
    // }))
    // locationOptions.push(...Object.entries(DepotList).map(([value,label])=>({value,label})).filter(({value})=>!Object.values(locationIDList[k]).includes(value)))
    const notEmpty = (a:any[]) => a?.length ? a : null
    const locationOptions = notEmpty(Object.entries(locationIDList[k]).map(([value,label])=>({value,label}))) ?? Object.entries(DepotList).map(([value,label])=>({value,label})).filter(({value})=>value.startsWith(country))
    console.log({k,response,loading,locationOptions,allVehicles})
    useEffect(()=>{
        if(!location) {
            console.log('must set location in',k)
            return
        }
        setLoading(true)
        GET(`/api/operator-config?${new URLSearchParams({operator:k,pickup:date.getTime(),location} as any).toString()}`).then(res => {
            setResponse(res?.operators?.[k] ?? res)
            setLoading(false)
        })
    }, [location, date])

    // const {
    //     known: knownV,
    //     unknown: unknownV,
    //     missing: missingV,
    // } = sortKnownUnknown((operator?.options?.available??[]).map(l=>l?.id), operator.operator?.products??[])
    
    const searchHandler = () => setTimeout(()=>setLocation(location??locationOptions[0].value), Math.random()*15e3)
    useEffect(()=>{
        document.addEventListener('do-search', searchHandler);
        return () => {
            document.removeEventListener('do-search',searchHandler)
        }
    }, [])

    return <div style={{
        // border:'2px black solid',
        flexGrow: 1,
        width:'450px',
        margin: '20px',
        height: 'auto',
        padding: '30px 25px 30px 25px',
        backgroundColor: 'rgba(245, 245, 245, 0.7)',
      }}>
        <Stack style={{
            alignItems: 'start',
            flexDirection: 'row',
            justifyContent: 'space-between',
            padding: '10px',
        }}>
            <h1>{country?.toUpperCase()} {OperatorList[k] ?? k}:</h1>
            <div style={{
                width: '200px',
                alignItems: 'end',
                flexDirection: 'row',
                justifyContent: 'space-between',
            }}>
                <DatePicker
                    value={date}
                    onChange={setDate}
                    clearable={false}
                    placeholder="Select"
                    label={'Pickup date (20 day trip)'}
                    disabled={loading}
                />
                <Select
                    data={locationOptions}
                    onChange={l=>{
                        console.log({l})
                        setLocation(l)
                    }}
                    value={location?.toString() ?? '-'}
                    label={location ? 'Depot (from,to)' : 'Must select location to search'}
                    searchable={false}
                    clearable={false}
                    disabled={loading}
                />
            </div>
        </Stack>
        <hr/>
        <div>
            {/* <h2>Depots:</h2>
            <Card>
                <Card color={WarningRed}><b>Warning:</b> Cannot list depot location data using current provider API.</Card>
                <Card color={WarningRed}><b>Warning:</b> SalesForce does not yet support operator configuration.</Card>
                {missingL.map(l => { // we have a mapping to this location ID but it is not on the API
                    return (<Tooltip label="Location">
                        <Badge
                            color={'red'}
                            variant="filled"
                            style={{ cursor: 'pointer' }}
                            onClick={e => setLModal([k,operator.operator.config.locations[l]].join('.'))}
                        >{`MISSING:${l}:${operator.operator.config.locations[l]}`}</Badge>
                    </Tooltip>)
                })}
                {knownL.map(l => { // we have a mapping to this location ID and it is on the API
                    return (<Tooltip label="Location">
                        <Badge
                            color={'green'}
                            variant="filled"
                            style={{ cursor: 'pointer' }}
                            onClick={e => setLModal([k,listKeysWithValue(operator.operator.config.locations, l).join(',')].join('.'))}
                        >{`${listKeysWithValue(operator.operator.config.locations, l).join(',')}:${l}`}</Badge>
                    </Tooltip>)
                })}
                {unknownL.map(l => { // locations from the API which we have no mapping for
                    return (<Tooltip label="Location">
                        <Badge
                            color={'gray'}
                            variant="filled"
                            style={{ cursor: 'pointer' }}
                            onClick={e => setLModal([k,'new',l].join('.'))}
                        >{`unknown:${l}`}</Badge>
                    </Tooltip>)
                })}
            </Card> */}
        </div>
        <h2>Models:</h2>
        <Card style={{padding:'2rem'}}>
            {Object.entries(allVehicles).map(([id,vehicleAvailability]) => { // we have a mapping to this vehicle ID but it is not on the API
                const {info,isUnavailable,isUnknown,rp_id,k} = vehicleAvailability ?? ({} as any)
                console.log({info,isUnavailable,isUnknown,rp_id,k,operator})
                const color = (loading || (!response))?(isUnavailable?grey:lightgreen):(isUnknown?red:(isUnavailable?orange:green))
                const days = 21
                const daily = info?.daily ?? info?.total/days ??0
                const label = isUnavailable ? `${info?.name ?? 'UNKNOWN'}:${id}` : `${info?.name ?? 'UNKNOWN'}:${id} (${((daily)/100).toFixed(2)}/d) [${info?.policies?.length}]`
                return (<Tooltip label={isUnknown?'Unknown vehicle from API':(isUnavailable?'Unavailable vehicle':'Available vehicle')} style={{zIndex:99}}>
                    <Badge
                        color={color}
                        variant="filled"
                        style={{ cursor: 'pointer', margin: '5px', zIndex: 99, backgroundColor: color }}
                        onClick={e => setVModal(vehicleAvailability)}
                    >{label}</Badge>
                </Tooltip>)
            })}
            {/* {missingV.map(l => { // we have a mapping to this vehicle ID but it is not on the API
                return (<Tooltip label="Vehicle">
                    <Badge
                        color={'red'}
                        variant="filled"
                        style={{ cursor: 'pointer' }}
                        onClick={e => setVModal([k,operator.operator.config.locations[l]].join('.'))}
                    >{`MISSING:${l}:${operator.operator.config.locations[l]}`}</Badge>
                </Tooltip>)
            })}
            {knownV.map(l => { // we have a mapping to this vehicle ID and it is on the API
                return (<Tooltip label="Vehicle">
                    <Badge
                        color={'green'}
                        variant="filled"
                        style={{ cursor: 'pointer' }}
                        onClick={e => setVModal([k,listKeysWithValue(operator.operator.config?.locations??[], l).join(',')].join('.'))}
                    >{`${listKeysWithValue(operator.operator.config.locations, l).join(',')}:${l}`}</Badge>
                </Tooltip>)
            })}
            {unknownV.map(l => { // Vehicles from the API which we have no mapping for
                return (<Tooltip label="Vehicle">
                    <Badge
                        color={'gray'}
                        variant="filled"
                        style={{ cursor: 'pointer' }}
                        onClick={e => setVModal([k,'new',l].join('.'))}
                    >{`unknown:${l}`}</Badge>
                </Tooltip>)
            })} */}
        </Card>
        <Fold title={"Debug Info"} key="operator"><pre style={{fontSize:'10px', overflow:'clip',textOverflow:'clip'}}>{JSON.stringify(response,null,4)}</pre></Fold>

    </div>

}
// export const V2 = () => {
//     const [Operators,setOperators] = useRecoilState(operatorConfigAtom(query))
// }

export type SF_Product2Minimal = {
    // Id: string;
    Name: string;
    CurrencyIsoCode: "AUD"|'NZD';
    Fridge__c: boolean;
    Toilet__c: boolean;
}
import bgImg from '../ratpack-ui/src/assets/images/background-road.jpg';
import { AdminCreateQuotePage } from '../ratpack-ui/src/pages/AdminCreateQuotePage';
import { PublicQuotePage } from '../ratpack-ui/src/pages/PublicQuotePage';
import { OfferExpiring } from './quote';
import { ItemBox } from '../ratpack-ui/src/components/ItemBox/ItemBox';
import { useMediaQuery } from '@mantine/hooks';
import { MdOutlineOpenInNew } from 'react-icons/md';


const Fold = ({title,children,key='only'}) => {
    return <Accordion>
    <Accordion.Item value={key}>
        <Accordion.Control styles={{control:{backgroundColor:hotPink}}}>{title??'Title Missing'}</Accordion.Control>
        <Accordion.Panel>{children??'Content Empty'}</Accordion.Panel>
    </Accordion.Item>
</Accordion>
}
export default () => {
    const [query,setQuery] = useState<operatorConfigQuery>({})
    const [Operators,setOperators] = useRecoilState(operatorConfigAtom(query))
    const [helpModal,setHelpModal] = useState(false)
    const [LModal,setLModal] = useState('')
    const [VModal,setVModal] = useState<null|vehicleAvailability>(null)
    return (<AdminPageLayout {...adminDefaults({ page: 'operators' })} page={<>
        <MustLogIn />
        <AdminCreateQuotePage
            backgroundImage={bgImg}
            topSpace={<Space h={50} />}
            topBox={<Stack dir="row" style={{flexDirection:'row',justifyContent:'space-between'}}>
                <Button onClick={()=>document.dispatchEvent(new Event('do-search', {bubbles:true,cancelable:false}))}>Search All</Button>
                <Card style={{margin:'0 10px'}}>
                    TODO OVERVIEW
                </Card>
                <Button onClick={()=>setHelpModal(true)}>Help</Button>
            </Stack>}
            middleSpace={<Space h={20} />}
            bottomBox={
                <Group style={{alignItems: 'stretch'}}>
                    {Object.entries(Operators?.operators??{})?.map(([k,o]) => (<OperatorBlock k={k} operator={o} setVModal={setVModal} setLModal={setLModal}/>))}
                </Group>
            }
            searchArea={[]}
        />
        <Modal
            size="95%"
            opened={helpModal}
            onClose={()=>setHelpModal(false)}
        >
            <Card>
                <h2>Colors:</h2>
                <Badge
                    variant="filled"
                    style={{ cursor: 'pointer', margin: '5px', zIndex: 99, backgroundColor: lightgreen }}
                    onClick={e => {}}
                >{`Available based on recent quotes`}</Badge>
                <Badge
                    variant="filled"
                    style={{ cursor: 'pointer', margin: '5px', zIndex: 99, backgroundColor: green }}
                    onClick={e => {}}
                >{`Available based on live search`}</Badge>
                <Badge
                    variant="filled"
                    style={{ cursor: 'pointer', margin: '5px', zIndex: 99, backgroundColor: orange }}
                    onClick={e => {}}
                >{`Unavailable based on live search`}</Badge>
                <Badge
                    variant="filled"
                    style={{ cursor: 'pointer', margin: '5px', zIndex: 99, backgroundColor: red }}
                    onClick={e => {}}
                >{`Available unknown product ID`}</Badge>
                <Badge
                    variant="filled"
                    style={{ cursor: 'pointer', margin: '5px', zIndex: 99, backgroundColor: grey }}
                    onClick={e => {}}
                >{`Loading / Error / No Data`}</Badge>
            </Card>
            <Card>
                <h2>Format:</h2>
                <Badge
                    variant="filled"
                    style={{ cursor: 'pointer', margin: '5px', zIndex: 99, backgroundColor: grey }}
                    onClick={e => {}}
                >{`[name]:[id] $[daily] [numberOfInsuranceOptions]`}</Badge>
            </Card>
            <Card>
                <h2>Notes:</h2>
            </Card>
        </Modal>
        <Modal
            size="95%"
            opened={!!LModal}
            onClose={()=>setLModal('')}
        >
            {LModal && (<p> Location Modal</p>)}
        </Modal>
        <Modal
            size="95%"
            opened={!!VModal}
            onClose={()=>setVModal(null)}
            title={`Product: "${VModal?.info?.name ?? "Unknown"}" (API:${VModal?.info?.id})`}
            style={{fontSize:'14px'}}
        >
            {VModal && (<div>
                <Button href="#" onClick={async e => {
                    const create = {
                        // ...VModal,
                        // "CurrencyIsoCode": "AUD"
                        "API_ID__c": VModal.info.id,
                        // "Condition__c": "Budget"  | "Old Model"  | "New Model"
                        // "Full_Payment_Deposit__c": "Full Payment"  | "Deposit"
                        "Brand__c": VModal.k,
                        // "Transmission__c": "Automatic"  | "Manual"
                        "ZDID__c": `new_sf_product_${Date.now()}`,
                        CurrencyIsoCode: {
                            au: 'AUD',
                            nz: 'NZD'
                        }[(VModal.k??'au').split('.')[0]] ?? 'AUD',
                        Name: VModal.known[0]?.name ?? VModal.avail[0]?.name ?? (VModal.avail[0] as any)?.option?.Name ?? 'New Vehicle',
                        Fridge__c: false,
                        Toilet__c: false,
                    } as SF_Product2Minimal
                    const res = await POST('/api/create_product', create)
                    if(res.error) return alert(res.error)
                    window.open(res.edit, '_blank');
                }}>{VModal.isUnknown ? 'CREATE IN SF':'EDIT IN SF'}</Button>
            </div>)}
            <Fold title={"Product Info"} key="product">
                <Table>
                    <thead><th>Property</th><th>RPQT (SF/JSON)</th><th>API</th></thead>
                    <tbody>{Object.entries(Object.assign({},VModal?.known[0]??{},VModal?.avail[0]??{})).map(([k],i)=>{
                        return <tr style={{backgroundColor:(i%2)?'white':'#eee'}}>
                            <td style={{minWidth:'200px'}}>{k}</td>
                            <td style={{minWidth:'33%'}}><pre style={{fontSize:'10px', overflow:'clip', whiteSpace:'pre-wrap', textOverflow:'clip'}}>{JSON.stringify((VModal?.known[0]??{})[k] ?? '-',null,4)}</pre></td>
                            <td style={{minWidth:'33%'}}><pre style={{fontSize:'10px', overflow:'clip', whiteSpace:'pre-wrap', textOverflow:'clip'}}>{
                                JSON.stringify(
                                    (VModal?.avail[0][k]) ?? 
                                    ((VModal?.avail[0] as any)?.option??{})[k] ??
                                    '-',
                                null,4)
                            }</pre></td>
                        </tr>
                    })}</tbody>
                </Table>
            </Fold>
            {/* <Fold title={"Quote"} key="operator"><ItemBoxElement/></Fold> */}
            <Fold title={"Debug Info"} key="debug"><pre>{JSON.stringify(VModal,null,4)}</pre></Fold>
        </Modal>
    </>} />)
}

const ItemBoxElement = (option:Option) => {
    const [region,slug] = option.provider_key?.split('.')
    const smallImages = useMediaQuery('(max-width: 500px)');
    const imagesReady = {} // TODO: wrap imagesReady from quote.tsx into a hook
    const carousel = {}

    const pluralBooster = option.boosterSeats > 1 ? `Seats` : `Seat`
    const booster = option.boosterSeats ? [{ icon: iconBaby, text: `${option.boosterSeats} Baby / Booster ${pluralBooster}` }] : []

    return <PublicQuotePage.ItemBox
        {...({
            imageCarouselContent:
                <Skeleton visible={!imagesReady[option?.imagesLink]} style={{ height: '100%' }}>
                    {ItemBox.ImageCarouselContent({
                        overlay: ItemBox.ImageCarouselOverlay({
                            overlayIconSrc: `/images/${region}.${slug}.png`,
                            overlayText: '',
                            height: smallImages ? 50 * 0.65 : 50,
                            fit: 'contain',
                            style:({}),
                        }),
                        carousel: imagesReady[option.imagesLink] ? <ItemBox.ImageCarouselCarousel {...carousel} loader={null} /> : null
                        // carousel: <ItemBox.ImageCarouselCarousel {...carousel} loader={null} />
                    })}
                </Skeleton>,


            topInfoBasicContent: ItemBox.TopInfoBasicContent({
                heading: option.name,
                info: [
                    option.pax?`${option.pax} passengers`:null,
                    option.bed,
                    option.transmission,
                ].filter(Boolean).join(' / ').replace('Automatic', 'Auto'),
            }),
            topInfoDetailsContent: ItemBox.TopInfoDetailsContent({
                infoList: [option.fridge, option.amenity, option.newness].filter(Boolean),
                specsTitle: <>
                    <a href={option.specs} target="_blank">Camper Spec <MdOutlineOpenInNew /></a>
                    {option.youtubeLink && <>
                        <br />
                        <a href={option.youtubeLink} target="_blank">Video Link <MdOutlineOpenInNew /></a>
                    </>}
                </> as any,
                specsList: [
                    ...booster,
                ],
            }),
            priceContent: ItemBox.PriceContent({
                normalPrice: '-',
                discountPrice: '-',
                timeUnit: ' / day',
                totalDiscountPrice: '-',
            }),
            bottomInfoContent: <OfferExpiring
                discount_expiry={new Date('2035').getTime()}
                discount_percent={0}
                onRequest={() => {}}
            />,
        })}
    />
}